export default __webpack_public_path__ + "static/media/mobile-app.92329f38.png";